var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"downLoad"},[_c('div',{staticClass:"download_box"},[_c('img',{attrs:{"src":"","alt":""}})]),_c('div',{staticClass:"download_box"},[_c('img',{attrs:{"src":"","alt":""}})])])
}]

export { render, staticRenderFns }